import type { onboarding as pt } from '../pt/onboarding';
// English mirror of ../pt/onboarding.ts (shape checked against its pt twin).
export const onboarding: typeof pt = {
  submissions: {
    cards: {
      pendingReview: 'To review',
      changesRequested: 'Changes requested',
      pendingSistrade: 'Pending SISTRADE',
      launched: 'Launched',
      rejected: 'Rejected',
      total: 'Total',
    },
    title: 'Onboarding records',
    loading: 'Loading…',
    countOne: '{n} record',
    countOther: '{n} records',
    searchPlaceholder: 'Search by name, email or department…',
    filter: 'Filter: {label}',
    searchButton: 'Search',
    empty: 'No records.',
    columns: {
      name: 'Name',
      email: 'Email',
      department: 'Department',
      source: 'Source',
      status: 'Status',
      received: 'Received',
    },
  },

  detail: {
    loading: 'Loading…',
    notFound: 'Record not found.',
    back: 'Back',
    edit: 'Edit',
    fields: {
      email: 'Email',
      phone: 'Phone',
      jobTitle: 'Role',
      department: 'Department',
      researchGroup: 'Research group',
      startDate: 'Start date',
      source: 'Source',
      requestedBy: 'Requested by',
      received: 'Received',
      reviewedBy: 'Reviewed by',
      reviewNote: 'Review note',
      sistradeReference: 'SISTRADE reference',
    },
    extraInfo: 'Additional information',
    notes: 'Notes',
    actions: 'Actions',
    notePlaceholder: 'Note (required when requesting changes, optional otherwise)…',
    approve: 'Approve',
    requestChanges: 'Request changes',
    reject: 'Reject',
    requestChangesHint: 'Write the note to send to the member',
    launchHelp:
      'After entering the data manually in SISTRADE, mark this record as launched. You can record the collaborator’s reference/ID (optional).',
    sistradeReferenceOptional: 'SISTRADE reference (optional)',
    markLaunched: 'Mark as launched in SISTRADE',
    editForm: {
      title: 'Edit details',
      fullName: 'Full name',
      email: 'Email',
      phone: 'Phone',
      startDate: 'Start date',
      jobTitle: 'Role / position',
      department: 'Department',
      researchGroup: 'Research group',
      notes: 'Notes',
      cancel: 'Cancel',
      saving: 'Saving…',
      save: 'Save',
    },
  },

  requests: {
    titleManager: 'Registration invites',
    titleMine: 'My requests',
    loading: 'Loading…',
    countOne: '{n} invite',
    countOther: '{n} invites',
    newRegistration: 'New Registration',
    empty: 'You have not created any registration requests yet.',
    columns: {
      requester: 'Requester',
      recipient: 'Recipient',
      method: 'Method',
      status: 'Status',
      created: 'Created',
      expires: 'Expires',
    },
    viewSubmission: 'View submission',
    cancel: 'Cancel',
  },

  new: {
    title: 'New Registration',
    subtitle: 'Invite or register a new person at CIIMAR',
    choice: {
      prompt: 'How would you like to register the new person?',
      emailTitle: 'Email',
      emailDesc: 'Enter the person’s email; the system sends them the link.',
      linkTitle: 'Link',
      linkDesc: 'Generate a link to send yourself.',
      directTitle: 'Fill in now',
      directDesc: 'In-person registration: creates the collaborator record directly.',
    },
    picker: {
      change: 'Change',
      placeholder: 'Search for a responsible person by name, code or email…',
    },
    chooseAnother: 'Choose another option',
    invite: {
      titleEmail: 'Registration by email',
      titleLink: 'Registration by link',
      createError: 'Could not create the invite.',
      emailLabel: 'Person’s email *',
      responsibleHelp:
        'Responsible person (optional) — who accompanies the new person. Brings useful context (team/group) to the registration.',
      internalNote: 'Internal note',
      submitting: 'Creating…',
      submitEmail: 'Send invite',
      submitLink: 'Generate link',
      createdTitle: 'Invite created',
      sentEmailPre: 'We sent the registration link to ',
      sentEmailPost: '.',
      shareLink: 'Share this link with the person to register:',
      codePre: 'Ask the person to go to ',
      codePost: ' and enter this code:',
      copy: 'Copy',
      copied: 'Copied!',
      expiresNote: 'The invite is linked to you and expires automatically.',
      createAnother: 'Create another registration',
    },
    direct: {
      title: 'New collaborator',
      help: 'In-person registration: creates the record directly. The rest of the data is filled in on the collaborator’s record.',
      createError: 'Could not create the collaborator.',
      fullName: 'Full name *',
      professionalEmail: 'Professional email',
      submitting: 'Creating…',
      submit: 'Create and open record',
    },
  },
};
